import { Flex, Text } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router';
import FaceliftTabs from '@/components/Atoms/FaceliftTabs';
import { selectUser, useAuthStore } from '@/store/authStore';
import Clinics from './Clinics';
import General from './General';
// import Locations from './Locations';
import Notifications from './Notifications';
// import Products from './Products';
// import SalesReps from './SalesReps';
import Settings from './Settings';
import Tutorials from './Tutorials';


const Profile = () => {
	const user = useAuthStore(selectUser);
	const port = user?.userInformation.portsAvailable;
	const [searchParams] = useSearchParams();
	const [tab, setTab] = useState('0');

	// Define tab titles and contents based on port type
	const tabTitles = useMemo(() => port === 'SalesRep' ? [
		'General',
		'Clinics',
		// 'Locations',
		// 'Products',
		'Notifications',
		'Tutorials',
		'Settings',
	] : [
		'General',
		'Clinics',
		// 'Products',
		'Notifications',
		'Tutorials',
		'Settings',
	], [port]);

	const tabContents = useMemo(() => port === 'SalesRep' ? [
		<General key="general" />,
		<Clinics key="clinics" />,
		// <Locations key="locations" />,
		// <SalesReps key="salesreps" />,
		// <Products key="products" />,
		<Notifications key="notifications" />,
		<Tutorials key="tutorials" />,
		<Settings key="settings" />,
	] : [
		<General key="general" />,
		<Clinics key="clinics" />,
		// <Products key="products" />,
		<Notifications key="notifications" />,
		<Tutorials key="tutorials" />,
		<Settings key="settings" />,
	], [port]);

	// Activate tutorials tab if it comes in the query string
	useEffect(() => {
		const tabParam = searchParams.get('tab');
		if (tabParam === 'tutorials') {

			const tutorialsIndex = tabTitles.indexOf('Tutorials');
			if (tutorialsIndex !== -1) {
				setTab(tutorialsIndex.toString());
			}
		}
	}, [searchParams, tabTitles]);
	
	return (
		<Flex
			direction="column"
			gap={4}
			rounded="md"
			shadow={{ _dark: '', _light: 'md' }}
			p={4}
			bg="brand.cardBackground"
		>
			<Text fontSize="2xl" fontWeight="bold">
				My Profile
			</Text>
			<FaceliftTabs
				value={tab}
				onValueChange={setTab}
				titles={tabTitles}
				contents={tabContents}
			/>
		</Flex>
	);
};

export default Profile;
